import React, { useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from "next-i18next";
import { ITagsData, ITags, IKeyFigureGroup } from "src/api/server/extended-search.types";
import { IconFilter } from "src/components/icons-mui/filter";
import { MobileSearchFilter } from "src/components/pages/search/components/filter-section/mobile-search-filter/mobile-search-filter";
import { Button } from "src/components-mui/base/button/button";
import { Container } from "src/components-mui/layout/container";
import { useIsCallerContentApp } from "src/lib/native-bridge/hooks/use-is-content-app";
import { SearchFilterHeader } from "../search-filter-header";
import { SearchResultCount } from "../search-result-count";

interface IMobileSearchFilterContainerProps {
    resultCount: number | null;
    isLoading: boolean;
    tagsData: ITagsData;
    popularKeyFiguresGroup: IKeyFigureGroup;
    keyFiguresGroupsWithIsPopularIndication: IKeyFigureGroup[];
    popularTags: ITags;
    onSearchTermClear: () => void;
    onReset: () => void;
    searchTerm?: string | string[];
}

export const MobileSearchFilterContainer = ({
    searchTerm,
    resultCount,
    isLoading,
    tagsData,
    popularKeyFiguresGroup,
    keyFiguresGroupsWithIsPopularIndication,
    popularTags,
    onSearchTermClear,
    onReset,
}: IMobileSearchFilterContainerProps) => {
    const { t } = useTranslation(["extended-search"]);
    const [isOpen, setIsOpen] = useState(false);
    const isCallerContentApp = useIsCallerContentApp();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    if (!isMobile) {
        return null;
    }

    return (
        <Container sx={{ backgroundColor: "gray.50", pt: 3, pb: 3, display: { xs: "block", sm: "none" } }}>
            {!isCallerContentApp && <SearchFilterHeader searchTerm={searchTerm} isMobile handleOnClear={onSearchTermClear} />}
            <SearchResultCount resultCount={resultCount} sx={{ mb: 2, display: { xs: "block", sm: "none" } }} />
            <Button startIcon={<IconFilter sx={{ width: 24, height: 24, mr: 1 }} />} onClick={() => setIsOpen(true)} fullWidth variant="contained">
                {t("buttons.filter")}
            </Button>
            <MobileSearchFilter
                isOpen={isOpen}
                isLoading={isLoading}
                resultCount={resultCount}
                tagsData={tagsData}
                popularKeyFiguresGroup={popularKeyFiguresGroup}
                keyFiguresGroups={keyFiguresGroupsWithIsPopularIndication}
                popularTags={popularTags}
                onClose={() => setIsOpen(false)}
                onReset={onReset}
            />
        </Container>
    );
};
